import axios from "axios";
import config from '../config';
import qs from "qs";

const INSTA_API_KEY = config.instagramAPIKey
const YOUTUBE_API_KEY = config.youtubeAPIKey
import siteconfig_data from '../jsondata/siteConfig.json';
import home_data from '../jsondata/home.json';
import contact_data from '../jsondata/contact.json';
import about_data from '../jsondata/about.json';
import books_data from '../jsondata/books.json';
import bookspage_data from '../jsondata/bookspage.json';
import event_data from '../jsondata/event.json';
import articles_data from '../jsondata/articles.json';
import video_data from '../jsondata/video.json';
//In order to work with local development env, you would haev to remove /proxy from the insta gram URLs below
const insta_user_id_url = '/proxy/v1/users/search?q=';
const insta_user_id_url_2 = '&access_token=' + INSTA_API_KEY
const insta_url = '/proxy/v1/users/';
const insta_url_2 = '/media/recent/?access_token=' + INSTA_API_KEY

const youtube_url = 'https://www.googleapis.com/youtube/v3/search?part=snippet&channelId='
const youtube_url_2 = '&maxResults=12&order=date&type=video&key=' + YOUTUBE_API_KEY
const youtube_user_id_url = 'https://www.googleapis.com/youtube/v3/channels?part=contentDetails&forUsername='
const youtube_user_id_url_2 = '&key=' + YOUTUBE_API_KEY

export function fetchInstagram(user_id) {
    const insta_request = axios.get(insta_url + user_id + insta_url_2)
    return {
        type: "FETCH_INSTAGRAM",
        payload: insta_request
    }
}

export function fetchInstagramUserID(username) {
    const insta_user_id_request = axios.get(insta_user_id_url + username + insta_user_id_url_2)
    return {
        type: "FETCH_INSTA_USER_ID",
        payload: insta_user_id_request
    }
}

export function fetchYoutube(user_id) {
    const youtube_request = axios.get(youtube_url + user_id + youtube_url_2)
    return {
        type: "FETCH_YOUTUBE",
        payload: youtube_request
    }
}

export function fetchYoutubeUserID(username) {
    const yt_user_id_request = axios.get(youtube_user_id_url + username + youtube_user_id_url_2)
    return {
        type: "FETCH_YT_USER_ID",
        payload: yt_user_id_request
    }
}

export function fetchContactData(author) {
   const contact_request = {data:contact_data};
    return {
        type: "FETCH_CONTACT_DATA",
        payload: contact_request
    }
}

export function fetchAboutData(author) {
    const contact_request = {data:about_data};
    return {
        type: "FETCH_ABOUT_DATA",
        payload: contact_request
    }
}

export function fetchArticlesData(author) {
    const contact_request = {data:articles_data};
    return {
        type: "FETCH_ARTICLES_DATA",
        payload: contact_request
    }
}

export function fetchEventsData(author) {
    const contact_request = {data:event_data};
    return {
        type: "FETCH_EVENTS_DATA",
        payload: contact_request
    }
}

export function fetchVideosData(author) {
    const contact_request ={data:video_data};
    return {
        type: "FETCH_VIDEOS_DATA",
        payload: contact_request
    }
}

export function fetchHomeData(author) {
    const contact_request ={data:home_data};
    return {
        type: "FETCH_HOME_DATA",
        payload: contact_request
    }
}

export function fetchSiteConfigData(author) {
    const contact_request = {data:siteconfig_data};
    console.log("contact_request",contact_request);
    return {
        type: "FETCH_SITE_CONFIG_DATA",
        payload: contact_request
    }
}

export function fetchBooksPageData(author) {
   const contact_request = {data:bookspage_data};
    return {
        type: "FETCH_BOOKS_DATA",
        payload: contact_request
    }
}

export function fetchBookDetails(author) {
    const contact_request = {data:books_data};
    return {
        type: "FETCH_BOOK_DETAIL_DATA",
        payload: contact_request
    }
}

export function newsletterSubscribe(user, listId) {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };
    const contact_request = axios.post('https://services.wwnorton.com/campmon/adduser',
        qs.stringify({ "email": user, "lists[0][listId]": listId ? listId : '58777ac5f15fe57eb70b334279594c0d',  "lists[0][optIn]": "true" }), config)
    return {
        type: "SUBSCRIBE",
        payload: contact_request
    }
}


// WEBPACK FOOTER //
// ./src/actions/actionCreators.js